import React from 'react';

export default function Pagination({ page, perPage, totalCount, sizes, setPage, setPerPage }) {
  const pageCount = Math.ceil(totalCount/perPage)
  const canGoPrev = page > 1
  const canGoNext = page < pageCount
  const availableSizes = sizes || [5, 10, 15, 20, 25]

  return (
    <div className='pagination'>
      <select name='page-size' className='page-size' value={perPage} onChange={e => {setPerPage(Number(e.target.value))}}>
        {availableSizes.map(pageSize => (
          <option key={pageSize} value={pageSize}>
            Show {pageSize}
          </option>
        ))}
      </select>
      <span className='viewing'>Viewing{' '}
        <strong>
          {(page-1)*perPage+1}-{page*perPage} of {totalCount}
        </strong>
      </span>
      <button className='button-prev' onClick={()=>{setPage(page-1)}} disabled={!canGoPrev}>
        <i className='fa fa-caret-left'></i>
      </button>
      <button className='button-next' onClick={()=>{setPage(page+1)}} disabled={!canGoNext}>
        <i className='fa fa-caret-right'></i>
      </button>
    </div>
  )
}
